export default __webpack_public_path__ + "static/media/image04.ba1bc5cd.jfif";